import styled from '@emotion/styled';
import { Divider, Grid } from '@kc-console/common-ui';

export const LnbDivider = () => {
  return (
    <LnbDividerContainer>
      <StyledLnbDivider />
    </LnbDividerContainer>
  );
};

const LnbDividerContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  margin: 8px 0;
  padding: 0 16px;
`;

const StyledLnbDivider = styled(Divider)`
  flex: 1;
  border-color: ${({ theme }) => theme.color['border/weak/default']};
`;
